<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-08-17 16:50:01
 * @Description:
-->
<template>
    <div class="media-wrap">
        <h1>{{$t('media.mediaInvestor')}}</h1>
        <ElForm label-position="left" :model="mediaInfo" ref="mediaInfo" :rules="mediaRules"
                class="mediaInfo">
            <ElFormItem :label="$t('fromData.name')" prop="partnerName">
                <ElInput v-model="mediaInfo.partnerName" maxlength="32"></ElInput>
            </ElFormItem>
            <ElFormItem :label="$t('fromData.company')" prop="companyName">
                <ElInput v-model="mediaInfo.companyName" maxlength="64"></ElInput>
            </ElFormItem>
            <ElFormItem :label="$t('fromData.position')" prop="position">
                <ElInput v-model="mediaInfo.position" maxlength="32"></ElInput>
            </ElFormItem>
            <ElFormItem :label="$t('fromData.email')" prop="email">
                <ElInput v-model="mediaInfo.email" type="email" maxlength="32"></ElInput>
            </ElFormItem>
            <ElFormItem :label="$t('fromData.productType')" prop="productType">
                <ElInput v-model="mediaInfo.productType" maxlength="32"></ElInput>
            </ElFormItem>
            <ElFormItem :label="$t('fromData.indication')" prop="indications">
                <ElInput type="textarea" v-model="mediaInfo.indications" maxlength="256"></ElInput>
            </ElFormItem>
            <ElFormItem label>
                <ElButton type="primary" class="sub-btn" @click="onSubmit">{{$t('media.submit')}}</ElButton>
                <ElButton class="sub-btn" @click="onReset">{{$t('media.reset')}}</ElButton>
            </ElFormItem>
        </ElForm>
    </div>
</template>
<script>
    import {PostMpAdd} from '../../api/web'

    export default {
        data() {
            return {
                mediaInfo: {
                    partnerName: '',
                    companyName: '',
                    position: '',
                    email: '',
                    productType: '',
                    indications: '',
                    companyId: 2
                },
                mediaRules: {
                    partnerName: [{required: true, message: " ", trigger: "blur"}],
                    companyName: [{required: true, message: " ", trigger: "blur"}],
                    position: [{required: true, message: " ", trigger: "blur"}],
                    email: [{required: true, message: " ", trigger: "blur"}],
                    productType: [{required: true, message: " ", trigger: "blur"}],
                    indications: [{required: true, message: " ", trigger: "blur"}],
                }
            }
        },
        methods: {
            onSubmit() {
                this.$refs.mediaInfo.validate((valid) => {
                    if (valid) {
                        PostMpAdd(this.mediaInfo).then(res=>{
                            if (res.status) {
                                this.$notify.success({
                                    title: '成功',
                                    message: '新增成功',
                                });
                            }
                        })
                    }})
            },
            onReset() {
                this.mediaInfo = this.$options.data().mediaInfo;
            },
        },
    }
</script>
<style lang="less" scoped>
    @import '../../style/constant';

    .media-wrap {
        width: @page-width;
        margin: 150px auto 80px;

        h1 {
            margin-bottom: 20px;
        }

        .mediaInfo {
            background: #fbfbfb;
            margin: 0 auto;
            padding: 5% 20%;
        }
    }
    @media screen and (min-width: 320px) and (max-width: 480px) {
      .media-wrap {
        width: 90%;
        .mediaInfo {
            padding: 5%;
        }
      }
    }
</style>
